import { FC } from 'react';
import classNames from 'classnames';
import { Tooltip, makeStyles } from '../uiLibraryImports';
import { TooltipContainerProps, tooltipType } from './tooltipTypes';
import styles from './tooltip.module.scss';

const TooltipContainer: FC<TooltipContainerProps> = (props: TooltipContainerProps) => {
    const {
        title,
        titleClassName = 'tooltip',
        children,
        dataTestid,
        enterDelay,
        open,
        placement,
        maxWidth,
        minWidth,
        type = 'primary',
        extraclasses = {},
        popperStyle = {},
        disablePortal = true,
        ...rest
    } = props;

    const typeProps = tooltipType[type];

    const useStyles = makeStyles(() => ({
        tooltip: {
            ...typeProps,
            margin: 0,
            zIndex: 8,
            maxWidth: maxWidth ? `${maxWidth} !important` : '',
            minWidth: minWidth ? `${minWidth} !important` : '',
            ...extraclasses
        },
        tooltipPlacementTop: {
            margin: '6px 0'
        },
        tooltipPlacementBottom: {
            margin: '6px 0'
        },
        tooltipPlacementRight: {
            margin: '0 6px'
        },
        tooltipPlacementLeft: {
            margin: '0 6px'
        },
        arrow: {
            '&::before': {
                border: typeProps.border,
                backgroundColor: typeProps.backgroundColor
            }
        }
    }));
    const classes = useStyles();

    const renderTitle = (): JSX.Element | string => {
        if (title === '') return '';
        return (
            <div data-testid={dataTestid} className={classNames(styles.tooltip, titleClassName)}>
                {title}
            </div>
        );
    };

    return (
        <Tooltip
            PopperProps={{ disablePortal, style: { zIndex: 2, ...popperStyle } }}
            data-testid={dataTestid}
            classes={{
                arrow: classes.arrow,
                tooltip: classes.tooltip,
                tooltipPlacementBottom: classes.tooltipPlacementBottom,
                tooltipPlacementLeft: classes.tooltipPlacementLeft,
                tooltipPlacementTop: classes.tooltipPlacementTop,
                tooltipPlacementRight: classes.tooltipPlacementRight
            }}
            arrow
            placement={placement}
            {...rest}
            title={renderTitle()}
            enterDelay={enterDelay ? 800 : undefined}
            open={open}
        >
            {children}
        </Tooltip>
    );
};

export default TooltipContainer;
